import { render } from "./Events.vue?vue&type=template&id=1d28b8d2&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=1d28b8d2&lang=css"
import "./Events.vue?vue&type=style&index=1&id=1d28b8d2&scoped=true&lang=css"

import exportComponent from "/builds/vidict/ott-platform/tvapp-procricket-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d28b8d2"]])

export default __exports__